'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_b66h0_1";
const styles = {
	root: root
};

function isLinkProps(props) {
  return typeof props.href === "string";
}
const StatusChip = (props) => {
  const { className, href, hrefLang, onPress, size, style, target, variant } = props;
  const getIconProps = () => {
    const iconSize = size === "medium" ? "var(--zds-size-20)" : "var(--zds-size-16)";
    if (variant === "warning") {
      return {
        name: "alertCircleColor",
        color: void 0,
        size: iconSize
      };
    } else if (variant === "error") {
      return {
        name: "formXCircle",
        color: "StatusErrorStronger",
        size: iconSize
      };
    } else {
      return {
        name: "formCheckCircle",
        color: "StatusSuccessStronger",
        size: iconSize
      };
    }
  };
  if (isLinkProps(props)) {
    return React__default.default.createElement(reactAriaComponents.Link, { className: clsx.clsx(styles.root, className), "data-size": size, "data-variant": true, "data-zds": true, href, hrefLang, onPress, target }, (linkRenderProps) => React__default.default.createElement(
      React__default.default.Fragment,
      null,
      React__default.default.createElement(designSystem.Icon, Object.assign({}, getIconProps())),
      typeof props.children === "function" ? props.children(linkRenderProps) : props.children
    ));
  }
  return React__default.default.createElement(reactAriaComponents.Button, { className: clsx.clsx(styles.root, className), "data-size": size, "data-variant": variant, "data-zds": true, onPress, style }, (buttonRenderProps) => React__default.default.createElement(
    React__default.default.Fragment,
    null,
    React__default.default.createElement(designSystem.Icon, Object.assign({}, getIconProps())),
    typeof props.children === "function" ? props.children(buttonRenderProps) : props.children
  ));
};

exports.StatusChip = StatusChip;
//# sourceMappingURL=StatusChip.cjs.js.map
